import React from "react"
import badge from "badges/conquer.svg"
import { BadgeImage } from "backpack/badges/styled"

const Conquer = props => <BadgeImage src={badge} {...props} />

export default Conquer
